<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
      <b-modal 
          v-model="showUploader"  
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
            <galerie-manager :__payload="dataUploaderPayload"></galerie-manager>
          </b-modal>

      <div class="editionPanel">
        <div class="row">

          <div class="col-md-2">
            <b-button @click="showUploader = true; isPDF = false" v-if="__item.pic ===''" size="sm" >
                  Image
                  </b-button>
                  <img :src="getTof(__item.pic)" v-else @click="showUploader = true" style="max-width: 98%; margin:1%"/>

                  
          </div>
          <div class="col-md-10">

            
            <div class="row">
            
              <div class="col-md-3 ">
                Référence
                <base-input
                  placeholder="Référence"
                  v-model="__item.ref"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

            <div class="col-md-9 ">
                Désignation
                <base-input
                  placeholder="Désignation"
                  v-model="__item.name"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-12" >
                <div class="row">
                  <div class="col-md-4 ">
                    Prix de revient HT
                    <base-input
                      placeholder="Prix de revient"
                      v-model="__item.prixA"
                      type = "price"
                      :range={min:0}
                      :error = "errorCtrl"
                    >
                    </base-input>
                  </div>

                  <div class="col-md-4 ">
                    Prix de vente HT
                    <base-input
                      placeholder="Prix de vente"
                      v-model="__item.prixV"
                      type = "price"
                      :range={min:0}
                      :error = "errorCtrl"
                    >
                    </base-input>
                  </div>

                 
                  <div class="col-md-4">
                  <selector _id="676c8c53590157a748c9c8b8" :_parentItem="__item" _warpper="catID" _customCss="background-color:#F2F2F2; padding: 3%; border-radius: 10px; float: left"></selector>
              </div>

                </div>
                  
              </div>

              


              <div class="col-md-12 pr-md-1" style="text-align: center; margin-bottom: 5px">
                <b-form-textarea
                  id="textarea-small"
                  size="sm"
                  placeholder="Description"
                  v-model="__item.desc"
                ></b-form-textarea>
              </div>
            </div>
            

            </div>
        </div>


        <div class="text-right">
          <div class="col-md-12" style="margin-top:5px;">
            
            <b-button size="sm" variant="danger"  @click="dispatchCancel()"> Fermer </b-button>
            <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>


export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      _packID: [],
      fullList: [],
      showUploader: false,
      isPDF: false,
      dataUploaderPayload: {
        folder: "prods",
        onFireCB: () => {},
        multiSelection: false,
        customClass: "customCatEditModal"
      },
      errorCtrl: [],
    }
  },
  methods: {
    onUpdateTpl(tpl) {
      this.$props.__item.template = tpl.data;
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/catalogue/No-Image.jpg');
      // return 'http://localhost:5000/uploads/'+c.split("/uploads/")[1];
      // return './uploads/'+c.split("/uploads/")[1];
    },

    dispatchSave() {
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },


   

  },
  mounted() {
    
    this.dataUploaderPayload.clientID = '67774320a78f8f1d12fb2380';
    this.dataUploaderPayload.onFireCB = (params) => {
      this.showUploader = false
      if(this.isPDF === true) {
        this.__item.fiche = this.getTof(params[0]);
      } else {
        this.__item.pic = params[0];
      }
     this.isPDF = false
    }
  },

  watch: {
    
  },


};
</script>
<style>
.modal-xl {
  max-width: 85% !important;
}
.editionPanel {
    width: 100%;
    padding: 2%;
    margin-bottom: 10px;
    border-radius: 10px;
    background-color: #fff;
}
.form-control option {
  color: black;
}
</style>

